import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CardType } from 'types'

interface cardFlowState {
  data: CardType | null,
}

const initialState: cardFlowState = {
  data: null,
}

export const cardFlowSlice = createSlice({
  name: 'cardFlow',
  initialState,
  reducers: {
    setCardData: (state, action: PayloadAction<CardType>) => {
      state.data = action.payload
    },
    clearCardData: (state) => {
      state.data = null
    },
  },
})

export const { setCardData, clearCardData } = cardFlowSlice.actions
export default cardFlowSlice.reducer
